module.exports = __webpack_public_path__ + "media/images/writer/home/home-02@3x-3a1a8a41078c6b15edeb0fa90fd92490.png";